var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    {
      staticClass: "content-header align-md-center flex-md-row",
      attrs: { "no-gutters": "" },
    },
    [
      _c(
        _vm.headerWrapper,
        {
          tag: "component",
          staticClass: "content-header__title flex-shrink-1",
          attrs: { to: _vm.to },
        },
        [
          _c(
            "v-row",
            {
              staticClass: "align-center flex-nowrap",
              staticStyle: { "min-width": "0" },
              attrs: { "no-gutters": "" },
            },
            [
              this.$slots.icon
                ? _c(
                    "div",
                    { staticClass: "mr-2 d-flex align-center flex-shrink-0" },
                    [_vm._t("icon")],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "d-flex flex-column",
                  staticStyle: { "min-width": "0" },
                },
                [
                  _c(
                    "div",
                    { class: _vm.headingClassNames },
                    [
                      _c(
                        "div",
                        {
                          class: _vm.titleClassNames,
                          staticStyle: { "min-width": "0" },
                          attrs: { "data-testid": "content-title" },
                        },
                        [
                          !!_vm.title
                            ? [_vm._v(_vm._s(_vm.title))]
                            : _vm.$slots.title
                            ? [_vm._t("title")]
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      !!_vm.subtitle && typeof _vm.subtitle === "string"
                        ? [
                            _c(
                              "div",
                              {
                                class: _vm.subtitleClassNames,
                                attrs: { "data-testid": "content-subtitle" },
                              },
                              [_vm._v(_vm._s(_vm.subtitle))]
                            ),
                          ]
                        : _vm.$slots.subtitle
                        ? [
                            _c(
                              "div",
                              { class: _vm.subtitleClassNames },
                              [_vm._t("subtitle")],
                              2
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.description
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "content-header__description caption my-1 hidden-sm-and-down",
                          attrs: { "data-testid": "content-description" },
                        },
                        [_vm._v(_vm._s(_vm.description))]
                      )
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _vm.hasCount
                ? _c("counter", {
                    staticClass: "hidden-md-and-up ml-auto",
                    attrs: { count: _vm.count },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm._t("default"),
      _vm._v(" "),
      _vm.hasCount
        ? _c("counter", {
            staticClass: "hidden-sm-and-down ml-auto",
            attrs: { count: _vm.count },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }